import {
  getTermCondition,
  setTermCondition,
  getTermConditionPublic,
} from '@/services/termsofcondition';

const getters = {
  contentTermsOfCondition: state => state.contentTermsOfCondition,
};

const actions = {
  async requestContentTermOfCondition({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isAdmin = rootGetters['AuthModule/isAdmin'];
      const result = await getTermCondition({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isAdmin);
      commit('SET_CONTENT_TOC', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestContentTermOfConditionPublic({ commit }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const result = await getTermConditionPublic();
      commit('SET_CONTENT_TOC', result.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async updateContentTermOfCondition({ commit, rootGetters }, content) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const isAdmin = rootGetters['AuthModule/isAdmin'];
      await setTermCondition(content, { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] }, isAdmin);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_CONTENT_TOC(state, content) {
    state.contentTermsOfCondition = content.content;
  },
};

export default {
  namespaced: true,
  state: {
    contentTermsOfCondition: '',
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/TermsOfCondition/index.js